import * as React from "react";
import { Outlet } from "react-router";
import MainLayout from "../../../components/atoms/MainLayout";
import { withRouter } from "../../../helpers/RouterHelper";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../../../hocs/enhanceAuthenticatedPage";
import withErrorPages from "../../../hocs/withErrorPages";
import SectionGlobalHeader from "../../SectionGlobalHeader";
import StudentSidebar from "../../StudentSidebar";

type Props = AuthenticatedPageProps & AuthenticatedPageCallbacks;
const StudentLayout = (props: Props) => {
  const [activeMenu, setActiveMenu] = React.useState<string>("");

  return (
    <MainLayout>
      <StudentSidebar {...props} activeMenu={activeMenu} />
      <SectionGlobalHeader {...props} />
      <Outlet context={{ setActiveMenu }} />
    </MainLayout>
  );
};

export default withRouter(
  withErrorPages(enhanceAuthenticatedPage(StudentLayout)),
);
